<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-caret-right`]" width="1em" height="1em" v-bind="$attrs"><path d="M16 9.162a1 1 0 011.648-.762l17.456 14.838a1 1 0 010 1.524L17.648 39.599A1 1 0 0116 38.838V9.162z"/></svg>
</template>
<script>

export default {
  name: 'IconCaretRight',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
